module.exports = __webpack_public_path__ + "_assets/img/success.432c427d.svg";